const SitePostCategory = () =>
  import(
    /* webpackChunkName: "site-generator-post-category" */ '@/pages/site-generator/base-info/post-category/index.vue'
  )
const CreateSitePostCategory = () =>
  import(
    /* webpackChunkName: "site-generator-post-category" */ '@/pages/site-generator/base-info/post-category/create.vue'
  )
const EditSitePostCategory = () =>
  import(
    /* webpackChunkName: "site-generator-post-category" */ '@/pages/site-generator/base-info/post-category/edit.vue'
  )

export default {
  path: 'post-category',
  meta: {
    label: 'postCategory',
    auth: 'postCategory'
  },
  component: {
    name: 'PostCategory',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SitePostCategoryReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: SitePostCategory
    },
    {
      name: 'SiteCreatePostCategory',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateSitePostCategory
    },
    {
      name: 'SiteEditPostCategory',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditSitePostCategory,
      props: true
    }
  ]
}
